function _changeTitleText(element, text) {
  element.text(text);
}

function _changeZIndex(element, zindex) {
  element.css('z-index', zindex);
}

export default {
  inserted(el, binding, vnode) {
    let fixedElementOffset;

    const fixedTitleElement = $(el).find('.changelog-fixed-title');
    const heightIncludingMargin = fixedTitleElement.outerHeight(true);

    
    _handleDateTitleChange();
    
    function handler(e) {
      e.onScroll = function (event) {
        if (e.scrollTop + e.offsetHeight + 20 >= e.scrollHeight) {
          vnode.context[binding.expression](event);
          event.preventDefault();         
        }

        _handleDateTitleChange();
      };
      e.addEventListener('scroll', el.onScroll);
    }

    function _handleDateTitleChange() {
      fixedElementOffset = fixedTitleElement.offset();
      const changeLogEntryElement = document.elementFromPoint(fixedElementOffset.left - window.scrollX, (fixedElementOffset.top + heightIncludingMargin + 10) - window.scrollY);
      _findAndChangeDateTitle(changeLogEntryElement);
    }

    function _findAndChangeDateTitle(changeLogEntryElement) {
      if (changeLogEntryElement && !$(changeLogEntryElement).hasClass('changelog-date-title')) {
        const dateTitle = $(changeLogEntryElement).closest('.changelog-list-items').find('.changelog-date-title');

        // Change element only if text is different
        if (dateTitle.length && fixedTitleElement[0].textContent !== dateTitle[0].textContent) {
          _changeTitleText(fixedTitleElement, dateTitle[0].textContent);
          _changeZIndex(fixedTitleElement, parseInt(dateTitle[0].style.zIndex) + 1);
        }
      }
    }

    handler(el);
  },
  unbind(el) {
    el.removeEventListener('scroll', el.onScroll);
  },

};